exports = module.exports = require("/Volumes/Work/ITCase/baikal430/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".Consist__params{display:-webkit-box;display:-ms-flexbox;display:flex}.Consist__params-col+.Consist__params-col{margin-left:3.5rem}.Consist__download{color:#fff;line-height:1}.Consist__download img{margin-right:10px}.Consist__download img,.Consist__download span{display:inline-block;vertical-align:middle}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib!./~/stylus-loader!./src/pages/Consist/Consist.styl
// module id = 225
// module chunks = 0